import React from 'react';
import { Award, Home, Handshake } from 'lucide-react';
import { Card } from './ui/card';

const ThreeTypes = () => {
  const types = [
    {
      icon: <Award className="w-12 h-12" />,
      category: 'PERSONAL ENERGY',
      title: 'Signature Feng Shui',
      description: 'Alignment of your personal energy (Qi). It reflects your confidence, mindset, wealth flow, and opportunities.',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/zsqenaqx_1%20copy.png'
    },
    {
      icon: <Home className="w-12 h-12" />,
      category: 'SPACE HARMONY',
      title: 'House Feng Shui',
      description: 'Harmonizes the energy of your living space to support health, relationships, and overall family prosperity.',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/ibb4mkly_2%20copy.png'
    },
    {
      icon: <Handshake className="w-12 h-12" />,
      category: 'BUSINESS GROWTH',
      title: 'Office Feng Shui',
      description: 'Empowering entrepreneurs with strategic financial planning to accelerate sustainable business growth.',
      image: 'https://customer-assets.emergentagent.com/job_feng-shui-signup/artifacts/xgwbyxi2_3%20copy.png'
    }
  ];

  return (
    <div className="py-24 bg-[#111113]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-4">
            Transform your <span className="italic text-[#F5A623]">Signature</span>—Transform your <span className="italic text-[#F5A623]">energy</span>—
          </h2>
          <h2 className="text-5xl font-bold text-white mb-4">
            Transform your <span className="italic text-[#F5A623]">life!</span>
          </h2>
          <p className="text-xl text-gray-400 mt-6 max-w-3xl mx-auto">
            Over 1,000 clients have used this system to gain clarity, make smarter moves, and create results that last.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {types.map((type, index) => (
            <Card 
              key={index}
              className="bg-[#1A1A1D] border-white/10 overflow-hidden group hover:border-[#F5A623]/50 transition-all duration-300 hover:scale-105"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover transition-transform duration-300"
                  style={{ objectPosition: 'center 60%' }}
                />
                <div className="absolute left-4 bg-[#F5A623] text-black px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider" style={{ top: '40%' }}>
                  {type.category}
                </div>
              </div>
              <div className="p-6 space-y-4">
                <div className="text-[#F5A623]">{type.icon}</div>
                <h3 className="text-2xl font-bold text-white">{type.title}</h3>
                <p className="text-gray-400 leading-relaxed">{type.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ThreeTypes;